import styled from 'styled-components';
import * as colors from '../../../../../../components/common/colorConstants';

export const ProductCheckbox = styled.input`
  margin: 0 15px 0 15px !important;
  border-radius: 0px;
  stroke: black !important;
  stroke-width: 2px;
  &:hover {
    cursor: pointer;
  }
`;

export const ProductCheckboxColumn = styled.div`
  display: inline-flex;
  align-items: center;
  margin-left: 8px;
  margin-right: 7px;
`;

export const ProductRow = styled.div`
  width: 100%;
  color: ${(props) => (props.checked ? colors.blackText : colors.darkGray9)};
  border-bottom: 1px solid ${colors.lightGray11};
  display: flex;
  padding: 17px 0;
  background-color: ${colors.baseBackground};
`;

export const ProductResultsColumn = styled.div`
  font-family: lato, sans-serif;
  font-weight: 400;
  line-height: 1.8rem;
  word-break: break-all;
  display: inline-flex;
  align-items: center;
  padding-right: 10px;
  font-size: 12px;
  width: ${(props) => props.width || 'auto'};
`;
